import CryptoJS from "crypto-js";
import { TOKEN_KEY, USER_KEY, SECRET_KEY } from "../constants";
/**
 * Manage how Access Tokens are being stored and retreived from storage.
 *
 * Current implementation stores to localStorage. Local Storage should always be
 * accessed through this instace.
 **/
const TokenService = {
  tokenExist() {
    return localStorage.getItem(TOKEN_KEY) ? true : false;
  },

  getToken() {
    let token = this.tokenExist() ?
      (CryptoJS.AES.decrypt(localStorage.getItem(TOKEN_KEY), SECRET_KEY)).toString(CryptoJS.enc.Utf8) : null;
    return token;
  },

  saveToken(accessToken) {
    let token = CryptoJS.AES.encrypt(accessToken, SECRET_KEY).toString();
    localStorage.setItem(TOKEN_KEY, token);
  },

  removeToken() {
    localStorage.removeItem(TOKEN_KEY);
  },

};

const UserService = {
  userExist() {
    return localStorage.getItem(USER_KEY) ? true : false;
  },
  
  getUser() {
    let user = this.userExist() ?
      (CryptoJS.AES.decrypt(localStorage.getItem(USER_KEY), SECRET_KEY)).toString(CryptoJS.enc.Utf8) : null;
    return JSON.parse(user);
  },
  
  saveUser(responseData) {
    let user = CryptoJS.AES.encrypt(JSON.stringify(responseData), SECRET_KEY).toString();
    localStorage.setItem(USER_KEY, user);
  },

  getToken() {
   return localStorage.getItem(USER_KEY)
  },

  removeUser() {
    localStorage.removeItem(USER_KEY);
  },
  isLoggedIn() {
    let user = this.getUser();
    return user == null ? false : true;
  },
};

const userAndTokenExist = () => {
  return TokenService.tokenExist() && UserService.userExist() ? true : false
}

export { TokenService, UserService, userAndTokenExist };